import { useCallback } from 'react';

import { fetchPrivateChatOptionsAction } from '../apiActions/fetchPrivateChatAction';
import { useCoreDispatch } from '../CoreStore';
import { useConfigSlice } from '../slices/config/selectors';

export const usePrivateChatOptionsFetcher = (): (() => void) => {
  const dispatch = useCoreDispatch();
  const chatOrigin = useConfigSlice.env()?.chat;
  const tableId = useConfigSlice.tableId() ?? '';

  return useCallback(() => {
    if (chatOrigin) {
      dispatch(fetchPrivateChatOptionsAction({ baseUrl: chatOrigin, tableId: tableId }));
    }
  }, [chatOrigin, dispatch, tableId]);
};
